import React from 'react';
import { Row, Col, Avatar, Checkbox } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Delete } from '../../../images/trash_gray.svg';
import { ReactComponent as Corona } from '../../../images/corona.svg';

const Wrapper = styled.div`
  &&& {
    background: white;
    padding: 9px 20px;
    border-radius: 6px;
    margin: 5px 0;
    .name {
      display: flex;
      align-items: center;
      div {
        &:nth-child(1) {
          color: #2b2828;
          border-bottom: 1px dotted;
        }
        &:nth-child(2) {
          color: #2b2828;
          border-bottom: 1px dotted;
          padding-left: 5px;
        }
      }
    }
    .root {
      display: flex;
      align-items: center;
      padding-left: 30px;
      div {
        &:nth-child(2) {
          padding-left: 10px;
        }
      }
    }
    .delete {
      display: flex;
      justify-content: flex-end;
    }
    &:hover {
      background: #e8f0f8;
    }
  }
`;

function User({ data, permissions }) {
  const {t} = useTranslation();
  return (
    <Wrapper>
      <Row type="flex" align="middle">
        <Col span={1}>
          <Avatar>{data.name[0]}</Avatar>
        </Col>
        <Col span={5}>
          <div className="name">
            <div>{data.name}</div>
            <div>{data.surname}</div>
            <div>
              <Corona className="ml-10" />
            </div>
          </div>
        </Col>
        <Col className="text-center" span={2}>
          <Checkbox
            checked={
              permissions.permissions[0] === 'full_access' ? true : false
            }
          />
        </Col>
        <Col className="text-center" span={2}>
          <Checkbox
            checked={
              permissions.permissions[0] === 'full_access' ? true : false
            }
          />
        </Col>
        <Col className="text-center" span={2}>
          <Checkbox
            checked={
              permissions.permissions[0] === 'full_access' ? true : false
            }
          />
        </Col>
        <Col className="text-center" span={2}>
          <Checkbox
            checked={
              permissions.permissions[0] === 'full_access' ? true : false
            }
          />
        </Col>
        <Col className="text-center" span={2}>
          <Checkbox
            checked={
              permissions.permissions[0] === 'full_access' ? true : false
            }
          />
        </Col>
        <Col className="text-center" span={4}>
          {permissions.permissions[0] !== 'full_access' ? (
            <div className="root">
              <div>
                <Corona />
              </div>{' '}
          <div>{t('giveFullAccess')}</div>
            </div>
          ) : null}
        </Col>
        <Col span={4}>
          <div className="delete">
            <Delete />
          </div>
        </Col>
      </Row>
    </Wrapper>
  );
}

User.propTypes = {};

export default User;
